export function generateBuyLinks(stub: {
  isbn13?: string
  asin?: string
}): { platform: string; url: string }[] {
  const links: { platform: string; url: string }[] = []

  if (stub.asin) {
    links.push({
      platform: 'Amazon',
      url: `https://amazon.com/dp/${stub.asin}`,
    })
  }

  if (stub.isbn13) {
    links.push({
      platform: 'Bookshop.org',
      url: `https://bookshop.org/books?keywords=${stub.isbn13}`,
    })
    links.push({
      platform: 'Barnes & Noble',
      url: `https://barnesandnoble.com/s/${stub.isbn13}`,
    })
    links.push({
      platform: 'Google Books',
      url: `https://books.google.com/books?vid=ISBN${stub.isbn13}`,
    })
  }

  return links
}

export function extractAsin(input: string): string | null {
  if (!input) return null
  const trimmed = input.trim()

  // If it looks like a raw ASIN (10 chars, alphanumeric, usually starts with B)
  if (/^[A-Z0-9]{10}$/.test(trimmed)) {
    return trimmed
  }

  // Extract from URL
  const match = trimmed.match(/(?:dp|o|asin|product)\/([a-zA-Z0-9]{10})/)
  if (match && match[1]) {
    return match[1]
  }

  return null
}

export function parseIsbnList(input: string): string[] {
  if (!input) return []
  return input
    .split(/[\n,]+/)
    .map((s) => s.trim().replace(/[- ]/g, ''))
    .filter((s) => s.length === 10 || s.length === 13)
}

export function getCsvTemplate(): string {
  const headers = [
    'title',
    'author_name',
    'format',
    'isbn_13',
    'isbn_10',
    'asin',
    'series_name',
    'series_position',
    'publication_date',
    'page_count',
    'language',
    'blurb',
    'content_warnings',
    'mood_tags',
    'pacing_tags',
    'spice_level',
    'darkness_level',
    'amazon_url',
    'bookshop_url',
    'bn_url',
    'audiobook_url',
    'narrator_name',
    'runtime',
  ].join(',')

  const exampleRow = [
    '"The Silent Echo"',
    '"Elena Richards"',
    'paperback',
    '9781234567890',
    '',
    'B08XYZ1234',
    '"Echo Series"',
    '1',
    '2023-10-15',
    '320',
    'English',
    '"A gripping thriller..."',
    '"Violence, Strong Language"',
    '"Dark, Suspenseful"',
    '"Fast-paced"',
    '2',
    '1',
    'https://amazon.com/dp/B08XYZ1234',
    '',
    '',
    '',
    '',
    '',
  ].join(',')

  return `${headers}\n${exampleRow}`
}
